import firebase from "firebase/app";

import { Card, Header } from "semantic-ui-react";

import React from "react";
import { useTranslation } from "react-i18next";

import updateDistributionChannel from "astrid-firestore/src/api/distribution/updateDistributionChannel";
import { Pipeline } from "astrid-firestore/src/api/pipelines/types/Pipeline";

import PrimaryButton from "../../../ui/components/Buttons/PrimaryButton";

import { useProfile } from "../../../authentication/state/profile";
import Form from "../../../forms/components/Form/Form";
import useSimpleForm from "../../../forms/hooks/useSimpleForm";

import PipelineSteps from "./components/PipelineSteps";

export default function PipelineForm({ header, channel, pipeline }) {
	const user = useProfile();
	const { t } = useTranslation();

	const form = useSimpleForm({
		schema: Pipeline,
		defaultValues: {
			name: pipeline.name || "",
			steps: pipeline.steps || null,
		},
		onSubmit: (data) => {
			return updateDistributionChannel(firebase, {
				ref: channel.ref,
				pipelines: { [pipeline.id]: data },
				updatedBy: user,
			});
		},
	});

	const { formState, onSubmit } = form;

	return (
		<>
			<Header as="h3">{header}</Header>

			<Card fluid>
				<Card.Content>
					<Form form={form}>
						<Form.Input name="name" label={t("name", "Name")} />

						<PipelineSteps name="steps" label={t("steps", "Steps")} />
					</Form>
				</Card.Content>

				<Card.Content>
					<PrimaryButton
						disabled={formState.isSubmitting || !formState.isDirty}
						loading={formState.isSubmitting}
						onClick={onSubmit}
					>
						{t("save", "Save")}
					</PrimaryButton>
				</Card.Content>
			</Card>
		</>
	);
}
